import { render, staticRenderFns } from "./StrategyResourceList.vue?vue&type=template&id=dae422b4"
import script from "./StrategyResourceList.vue?vue&type=script&lang=js"
export * from "./StrategyResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports